import React from "react";
import { Edit } from "react-feather";
import i18next from "i18next";
var LookAtIngredients = function (_a) {
    var handleIngredientsClick = _a.handleIngredientsClick;
    return (React.createElement("button", { className: "addon", onClick: handleIngredientsClick },
        React.createElement("span", null, i18next.t("productDetails.seeIngredients.top")),
        React.createElement(Edit, { size: 32 }),
        React.createElement("span", null, i18next.t("productDetails.seeIngredients.bottom"))));
};
export default LookAtIngredients;
